export class ParamSetting {
    constructor(
        public minYear: number = undefined,
        public maxYear: number = undefined,
        public skipParams: string[] = [], // urval som får appliceras på rapporten men ej visas i urvalsmeny (vid drilldown)
        public chooseAllYears: boolean = false
    ) { }
}